<template>
  <BreadCrumb :PageTitle="t('breadCrumb.changeMyPassword')" />
  <CoverImage />
  <ChangePassword />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { useI18n } from "vue-i18n";
import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import CoverImage from "../../components/Settings/CoverImage.vue";
import ChangePassword from "../../components/Settings/ChangePassword/ChangePassword.vue";

export default defineComponent({
  name: "ChangePasswordPage",
  components: {
    BreadCrumb,
    CoverImage,
    ChangePassword,
  },
  setup() {
      const { t } = useI18n();
      return {
      t,
    };
  }
});
</script>